module.exports = __webpack_public_path__ + "img/header-weddingRingsRingSets@2x.b39dc40.webp";